import { createContext, useContext } from 'react';

import type { AppConfig } from '../models';

export const appConfigContextDefaultValue: AppConfig = {
  currentLanguage: '',
  enableTopAreaBanner: false,
  graphqlUrl: '',
  mobileOfficeApiUrl: '',
  ssoAdLoginUrl: '',
  tenant: '',
  useSsoIdentityLogin: false,
  abTastyEnabled: false,
  onlyProductsTabInSearch: false,
};

export const appConfigContext = createContext<AppConfig>(appConfigContextDefaultValue);

export const { Provider: AppConfigProvider } = appConfigContext;

export const useAppConfig = () => useContext(appConfigContext);
